import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Cancel } from "@mui/icons-material";
import axios from "axios";
import { Toast } from "../../util/Toast";
import { useDispatch } from "react-redux";
import { getBd } from "../../store/Bd/action";

const BdCoinDialog = ({ open, onClose, bdData, page, rowsPerPage }) => {
  const dispatch = useDispatch();
  const [type, setType] = useState("add");
  const [coin, setCoin] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setCoin("");
    setType("add");
    onClose();
  };

  const handleSubmit = () => {
    if (!coin || isNaN(coin) || Number(coin) <= 0) {
      Toast("error", "Please enter a valid coin amount!");
      return;
    }

    setLoading(true);
    axios
      .post("bd/addDeductCoin", {
        bdId: bdData?._id,
        coin: Number(coin),
        type,
      })
      .then((res) => {
        if (res.data.status) {
          Toast("success", res.data.message);
          dispatch(getBd({ start: page, limit: rowsPerPage }));
          handleClose();
        } else {
          Toast("error", res.data.message);
        }
      })
      .catch((err) => Toast("error", err.message))
      .finally(() => setLoading(false));
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <span className="text-danger font-weight-bold h5">
          Adjust Coins for {bdData?.name}
        </span>
      </DialogTitle>

      <IconButton style={{ position: "absolute", right: 4, top: 4 }}>
        <Tooltip title="Close">
          <Cancel className="text-danger" onClick={handleClose} />
        </Tooltip>
      </IconButton>

      <DialogContent>
        <div className="pb-3">
          <p className="mb-4 text-white" style={{ fontSize: 14 }}>
            Current Coin rCoin :{" "}
            <span
              className="text-light"
              style={{ fontWeight: 600, fontSize: 16 }}
            >
              {bdData?.rCoin ?? 0}
            </span>
          </p>

          {/* Add / Remove toggle buttons */}
          <div className="d-flex gap-3 mb-4">
            <button
              type="button"
              className="btn"
              style={{
                background: type === "add" ? "#6c63ff" : "transparent",
                color: type === "add" ? "#fff" : "#6c63ff",
                border: "2px solid #6c63ff",
                fontWeight: 600,
                minWidth: 120,
                borderRadius: 6,
              }}
              onClick={() => setType("add")}
            >
              Add Coins
            </button>
            <button
              type="button"
              className="btn"
              style={{
                background: type === "deduct" ? "#e11d48" : "transparent",
                color: type === "deduct" ? "#fff" : "#e11d48",
                border: "2px solid #e11d48",
                fontWeight: 600,
                minWidth: 120,
                borderRadius: 6,
              }}
              onClick={() => setType("deduct")}
            >
              Remove Coins
            </button>
          </div>

          {/* Coin Input */}
          <div className="mb-4">
            <label
              style={{
                fontSize: 13,
                color: "#888",
                marginBottom: 6,
                display: "block",
              }}
            >
              {type === "add" ? "Coins to Add" : "Coins to Remove"}
            </label>
            <div style={{ position: "relative" }}>
              <span
                style={{
                  position: "absolute",
                  left: 12,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#888",
                  fontSize: 16,
                }}
              >
                ⭐
              </span>
              <input
                type="number"
                className="form-control"
                placeholder="Enter amount"
                value={coin}
                min={1}
                onChange={(e) => setCoin(e.target.value)}
                style={{ paddingLeft: 36 }}
              />
            </div>
          </div>

          {/* Action Buttons */}
          <div className="d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={handleClose}
              style={{ minWidth: 90 }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn"
              onClick={handleSubmit}
              disabled={loading}
              style={{
                background: "#6c63ff",
                color: "#fff",
                minWidth: 130,
                fontWeight: 600,
              }}
            >
              {loading ? "Updating..." : "Update Coins"}
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BdCoinDialog;
